import React, { FC } from "react";
import Spinner from "newComponents/Shared/_Atoms/Spinner/Spinner";
import colors from "constants/colors";
import Text from "newComponents/Shared/_Atoms/Text/Text";

interface IProps {
  fetchingText?: string;
  local?: boolean;
}

const GlobalSpinner: FC<IProps> = ({ fetchingText, local }) => {
  return (
    <div className={`global-spinner-container${local ? " local" : ""}`}>
      <Spinner
        showSpinner={true}
        className="global-spinner"
        color={colors[local ? "grey" : "white"]}
      />
      <Text customClass="global-spinner-text">{fetchingText || `Fetching Data...`}</Text>
    </div>
  );
};
export default GlobalSpinner;
